var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreasuryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.48 6.88905C19.48 4.35364 19.48 3.08728 18.7065 2.2995C17.933 1.51172 16.6895 1.51172 14.2 1.51172C11.7105 1.51172 10.467 1.51172 9.69352 2.2995C8.92 3.08728 8.92 4.35364 8.92 6.88905M1 17.6437C1 12.5742 1 10.0388 2.54704 8.4646C4.09276 6.88905 6.58228 6.88905 11.56 6.88905H16.84C21.8177 6.88905 24.3072 6.88905 25.853 8.4646C27.4 10.0388 27.4 12.5742 27.4 17.6437C27.4 22.7132 27.4 25.2486 25.853 26.8228C24.3072 28.3984 21.8177 28.3984 16.84 28.3984H11.56C6.58228 28.3984 4.09276 28.3984 2.54704 26.8228C1 25.2486 1 22.7132 1 17.6437Z",
    stroke: "#909090",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2001 22.1246C15.6587 22.1246 16.8401 21.1217 16.8401 19.8849C16.8401 18.6481 15.6587 17.6439 14.2001 17.6439C12.7415 17.6439 11.5601 16.6411 11.5601 15.4029C11.5601 14.1661 12.7415 13.1633 14.2001 13.1633M14.2001 22.1246C12.7415 22.1246 11.5601 21.1217 11.5601 19.8849M14.2001 22.1246V23.0213M14.2001 13.1633V12.2666M14.2001 13.1633C15.6587 13.1633 16.8401 14.1661 16.8401 15.4029",
    stroke: "#909090",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasuryIcon);
export default __webpack_public_path__ + "static/media/treasuryIcon.0e3e761a31cc2758b191ba1c9b99c924.svg";
export { ForwardRef as ReactComponent };